import { Snackbar, SNACKBAR_TYPES } from "@lysaab/ui-2";
import React from "react";
import { FormattedMessage } from "react-intl";

export const OnfidoFailedUserError: React.VFC = () => {
  return (
    <div className="snackbar-wrapper">
      <Snackbar type={SNACKBAR_TYPES.ERROR}>
        <FormattedMessage id="onfido.status.poa.onfido_failed_user_error" />
      </Snackbar>
    </div>
  );
};
